
const API_URL = "https://api.wishours.com";
//const API_URL = "http://localhost:5002";


const Apis = {
  UserLogin:`${API_URL}/api/auth/sign-in`,
  GetUserProfile:`${API_URL}/api/user/profile`,
  UserProfileUpdate:`${API_URL}/api/user/profile/update`,
  CheckUserCurrentPassword:`${API_URL}/api/user/check/password`,
  UserPasswordUpdate:`${API_URL}/api/user/update/password`,
  GetAllUsers:`${API_URL}/api/user/get-all-users`,
  GetSingleUser:`${API_URL}/api/user/get-single-users/`,
  AcivateDeactivateUser:`${API_URL}/api/user/activate-deactivate/`,
  SetUserRoles:`${API_URL}/api/user/set-user-roles`,
  UploadImages:`${API_URL}/admin/api/upload/images`,
  GetImages:`${API_URL}/admin/api/get-images`,
  RemoveImage:`${API_URL}/admin/api/remove-image/`,
  CreateImage:`${API_URL}/admin/api/create-image-edit/`,
  FetchCreatedImage:`${API_URL}/admin/api/fetch-image/`,
  CreateImageProperty:`${API_URL}/admin/api/add-image-property`,
  CreateImagePropertyOptions:`${API_URL}/admin/api/create-image-property`, 
  RemoveImageProperty:`${API_URL}/admin/api/remove-image-property`, 
  GetCategories:`${API_URL}/admin/api/category/all`, 
  GetCategoriesWithTopLevel:`${API_URL}/admin/api/category/top-level`, 
 
  CreateCategory:`${API_URL}/admin/api/category/create`, 
  DeleteCategory:`${API_URL}/admin/api/category/delete/`, 
  GetSingleCategory:`${API_URL}/admin/api/categories/`, 
  UpdateCategory:`${API_URL}/admin/api/categories/update/`, 
  RemoveCategoryThumb:`${API_URL}/admin/api/category/remove/thumbnail/`, 
  AddNewCategoryThumb:`${API_URL}/admin/api/category/add-new/thumbnail/`, 
  GetCreatedImages:`${API_URL}/admin/api/get-created-images`, 
  DeleteCreatedImage:`${API_URL}/admin/api/image-delete/`, 
  AddImagePropertyImage:`${API_URL}/admin/api/create-image-property-add-image`,
  GetHomeBanner:`${API_URL}/admin/api/home-banner`,
  UpdateHomeBanner:`${API_URL}/admin/api/update-home-banner`,
  CreateFaq:`${API_URL}/admin/api/create-faq`,
  GetFaqs:`${API_URL}/admin/api/get-faqs`,
  GetSingleFaq:`${API_URL}/admin/api/faqs/`,
  UpdateFaq:`${API_URL}/admin/api/faq/update/`,
  DeleteFaq:`${API_URL}/admin/api/faq/delete/`,
  UploadSampleGreetings:`${API_URL}/admin/api/sample-greetings/upload`,
  GetSampleGreetings:`${API_URL}/admin/api/get-sample-greetings`,
  DeleteSampleGreetings:`${API_URL}/admin/api/sample-greetings/delete/`,
  SaveCreatedImage:`${API_URL}/admin/api/save-created-image`,
  AddNewKeywordCreatedImage:`${API_URL}/admin/api/add-new-keyword-created-image`,
  DeleteKeywordCreatedImage:`${API_URL}/admin/api/keyword/delete/`,
  
};
export { API_URL, Apis };